
import wx from 'weixin-js-sdk';
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'

export default {
name: 'factoryStoreBack',
components: {
wx,XTextarea,Group,Popup,PopupHeader,XButton,Radio,
},
data () {
return {
id:0,
code:'',
content:'',
order:{
},
}
},
created(){
this.config();
},
mounted(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ["barCode"],
success: function (res) {
setTimeout(()=>{

that.code = res.resultStr.split(',')[1];
that.getOrder();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
getOrder(){
let that = this;
if(!this.code){
that.$func.showToast('衣物条码无效');
return ;
}




that.$func.startLoading();
this.$api.barOrder({code:this.code}).then((res)=>{
if(res){
that.order = res.data;
that.$func.endLoading();
}
})
},
submit(){
let that = this;
if(!this.code){
that.$func.showToast('衣物条码无效');
return ;
}
this.$func.confirm('确认提交厂外返洗？','提示',()=>{
this.$api.submitBackwash({code:this.code,content:that.content}).then((res)=>{
if(res){
that.$func.showToast('操作成功');
this.code = '';
this.content = '';
this.order = {};
}
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/factoryStoreBack.vue